module.exports = __webpack_public_path__ + "img/outcome.eccbd464.svg";